var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"py-0"},[_c('div',{staticClass:"tcdc-ebook-card",on:{"click":function($event){return _vm.onPress()}}},[_c('span',{staticClass:"tcdc-ebook-card-inside pa-5"},[_c('img',{staticClass:"tcdc-ebook-image",attrs:{"src":_vm.img,"loading":"lazy"}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }